import React, { useCallback, useEffect, useReducer, useRef, useState } from 'react'
import { produce } from 'immer'
import { Select, Tag, Input, Button, Row, Col } from 'antd'
import { selectOption, selectValue } from '../../common/mock'
import { DeleteOutlined } from '@ant-design/icons'
import styled from 'styled-components'
import { transformObjToSlsQuery } from '@/utils/sls'
import { getMultipleLabel } from '@/common/constant'
const { Search } = Input
// FIXME trackerId bug
// todo 暴露清空全部的方法
const types = {
  SET_OPTION: 'SET_OPTION',
  SET_VALUE: 'SET_VALUE',
  CLEAR_ITEM: 'clear item', // 清除item
}
const TagWrap = styled(Tag)`
  font-size: 14px;
  margin-bottom: 10px;
  padding: 4px 6px;
`
const initialState: SelectorItem[] = []

const reducers = produce((selected: SelectorItem[], action: { type: string; payload: SelectorItemNode | number }) => {
  const { type, payload } = action
  switch (type) {
    case types.SET_OPTION:
      selected.push({ option: payload as SelectorItemNode })
      break
    case types.SET_VALUE:
      selected[selected.length - 1].value = payload as SelectorItemNode
      break
    case types.CLEAR_ITEM:
      selected.splice(payload as number, 1)
      break
    default:
      return selected
  }
}, initialState)

const COLORS = ['magenta', 'red', 'volcano', 'orange', 'gold', 'lime', 'green', 'cyan']

interface SelectorItemNode {
  label: string
  value: string
}

export interface SelectorItem {
  option: SelectorItemNode
  value?: SelectorItemNode
}

/**
 * 多选项组件
 * 选择完option, 选择value
 * 当value 和 option 组合完，触发props.onChange时间
 * props.onChange: (res: SelectorItem[]) => any
 * */

interface MultiSelectorProps {
  onChange?: (res: string, raw?: SelectorItem[]) => unknown
  onSelectOption?: (option: SelectorItemNode) => unknown
  labelFetch: Function
  valueFetch: Function
  dataParams: any
  options?: SelectorItem[]
  values?: SelectorItem[]
  initial: SelectorItem[]
}

const MultiSelector = (props: MultiSelectorProps) => {
  const renderType = useRef(0) // 0 渲染options  1 渲染values
  const [selected, dispatch] = useReducer(reducers, props.initial)
  const [options, setOptions] = useState([])
  const [isInput, setIsInput] = useState(false)
  const switchRenderType = v => {
    renderType.current = v
  }

  const fetchLabels = async () => {
    const res = await props.labelFetch({ ...props.dataParams })
    // console.log(
    //   res.map(item => ({
    //     ...item,
    //     label: getMultipleLabel(item.value),
    //   })),
    // )
    setOptions(res)
  }
  const fetchValues = async (label: string) => {
    const res = await props.valueFetch({ ...props.dataParams, label })
    setOptions(res)
  }

  useEffect(() => {
    fetchLabels()
  }, [])

  const toSlsQuery = (selected: SelectorItem[]) => {
    const params = {}
    selected.forEach(item => {
      params[item.option.label] = item.value.label
    })
    console.log('sls:', transformObjToSlsQuery(params))
    return transformObjToSlsQuery(params)
  }

  useEffect(() => {
    if (renderType.current === 0 && props.onChange) {
      props.onChange(toSlsQuery(selected), selected)
    }
    // props, selected
  }, [selected])

  const onChange = (e, nodeArray) => {
    const { children, value } = nodeArray[0]
    const payload: SelectorItemNode = {
      label: children,
      value,
    }
    if (renderType.current === 0) {
      dispatch({ type: types.SET_OPTION, payload })
      props.onSelectOption && props.onSelectOption(payload)
      fetchValues(value)
      // setOptions(selectValue[value])
    } else {
      dispatch({ type: types.SET_VALUE, payload })
      fetchLabels()
    }
    switchRenderType(renderType.current === 0 ? 1 : 0)
  }
  // 支持在输入筛选value的时候允许查询没有在options的选项
  const onKeyDownEnter = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.keyCode === 13) {
        const el = e.currentTarget.querySelector('.ant-select-selection-search-input') as HTMLInputElement
        const inputValue = el.value.trim()
        const hasHit = options.find(({ value }) => value === inputValue)
        // 如果当前在value状态 并且没有select选项匹配
        if (!hasHit && inputValue) {
          const payload = { label: inputValue, value: inputValue }
          // 没有命中select options
          if (renderType.current === 1) {
            dispatch({ type: types.SET_VALUE, payload })
            el.blur()
            el.focus()
            fetchLabels()
            switchRenderType(0)
          }
        }
      }
    },
    [options],
  )

  const onCloseTag = (index: number) => {
    dispatch({ type: types.CLEAR_ITEM, payload: index })
    if (index === selected.length - 1) {
      switchRenderType(0)
      setOptions(selectOption)
    }
    fetchLabels()
  }
  const renderInput = () => {
    const onSearch = (value: string) => {
      props.onChange(value)
    }
    return (
      <Search
        enterButton
        placeholder="input search text"
        allowClear
        defaultValue={toSlsQuery(selected)}
        onSearch={onSearch}
      />
    )
  }
  const renderSelect = () => (
    <div style={{ position: 'relative' }}>
      <Row>
        <div>
          {selected.map(({ option, value }, i) => {
            return (
              <TagWrap key={option.value + i} color={COLORS[i % COLORS.length]}>
                {`${option.label}:${value?.label ?? '-'}`}
                <DeleteOutlined size={20} style={{ marginLeft: '5px' }} onClick={() => onCloseTag(i)} />
              </TagWrap>
            )
          })}
        </div>
      </Row>
      <Row className="no-wrap-row" gutter={[20, 0]}>
        <Col flex="auto">
          <Select
            placeholder="请选择筛选条件"
            value={[]}
            onChange={onChange}
            style={{ width: '100%' }}
            onKeyDown={onKeyDownEnter}
            mode="multiple"
          >
            {options.map(n => (
              <Select.Option
                disabled={selected.findIndex(item => n.value === item.option.value) > -1}
                value={n.value}
                key={n.value}
              >
                {n.label}
              </Select.Option>
            ))}
          </Select>
        </Col>
        <Col flex="116px">
          <Button size="middle" type="primary" onClick={() => setIsInput(true)}>
            切换到输入框
          </Button>
        </Col>
      </Row>
    </div>
  )

  return <div style={{ marginBottom: '10px' }}>{!isInput ? renderSelect() : renderInput()}</div>
}

export default MultiSelector
